module.exports = __webpack_public_path__ + "granuli_pe-img@2x.jpg?95f988e08c449e0947cc5fce89658565";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/granuli_pe-img@2x.jpg
// module id = 194
// module chunks = 0